
/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */

require('spark-bootstrap');
require('./components/bootstrap');
import VueRouter from 'vue-router';
import VTooltip from 'v-tooltip';
import underscore from 'vue-underscore';
import * as VueGoogleMaps from 'vue2-google-maps';
import {MediaQueries, CommonBands} from 'vue-media-queries';

import Vue from 'vue'

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
  dsn: 'https://132299daaedb486fb6f68b7e11759ab4@sentry.io/1768248',
  integrations: process.env.NODE_ENV === 'production' ? [new Integrations.Vue({Vue, attachProps: true})] : [],
});

import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: '90a495229fcea135d83e',
    cluster: 'us2',
    encrypted: true,
});

Vue.use(VueRouter);

const sparkWrapper = require('./spark-wrapper');

import Projects from './components/home/projects/Projects';
import ProjectForm from './components/home/projects/ProjectForm';

const routes = [
	{ path: '/test/tom', component: Projects },
	{ path: '/test/tim', component: ProjectForm },
];

const router = new VueRouter({routes});

const mediaQueries = new MediaQueries({
  bands: CommonBands.Bootstrap4
});

Vue.use(mediaQueries);
Vue.use(VTooltip)
Vue.use(underscore);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAN_u8FB5ZLh02zKSVquwvp0GEcfRZpQMs',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
 
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,
 
  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

// Extend registration to include phone
Spark.forms.register = {
    phone: ''
};

var app = new Vue({
    mixins: [require('spark'), CommonBands.Bootstrap4.mixin],
    router,
    mediaQueries: mediaQueries
});